import { Controller, Control } from 'react-hook-form';
import { Checkbox, FormControlLabel, FormControlLabelProps } from '@mui/material';

type ControlledTextFieldProps = {
    name: string;
    control: Control<any>;
    label: string;
} & Omit<FormControlLabelProps, 'control' | 'label'>;

export default function CheckboxLabel({ name, control, label, ...rest }: ControlledTextFieldProps) {
    return (
        <Controller
            name={name}
            control={control}
            render={({ field: { value, onChange, ref, ...field } }) => (
                <FormControlLabel
                    {...rest}
                    control={
                        <Checkbox
                            {...field}
                            inputRef={ref}
                            checked={!!value}
                            onChange={(e) => onChange(e.target.checked)}
                        />
                    }
                    label={label}
                />
            )}
        />
    );
}
